import React, { Component } from "react";

class UkSelfEmpLaw extends Component {
  render() {
    return (
      <div className="flex-center-center" style={{ height: "500px" }}>
        <h3>UK self-employment law</h3>
      </div>
    );
  }
}

export default UkSelfEmpLaw;
